import { render } from "./AboutMe.vue?vue&type=template&id=0042e290&scoped=true"
const script = {}

import "./AboutMe.vue?vue&type=style&index=0&id=0042e290&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0042e290"]])

export default __exports__